import indicadorReportSummary from "entity/Indicador/reports/IndicadorReportSummary";
import TableReportHelper from "report/helper";
import { parseDuration } from "util/datetime";

export default async function ttcReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;
    // console.log('visita.cliente',visita.cliente)
    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type);
    // console.log('params', params)
    if (!params) {
        return null;
    }

    // const convertedParams = {
    //     ...params,
    //     // meta: parseDuration(params.meta),
    // };

    async function getChart(conformidade, status) {
        let barColor;

        switch (status) {
            case "Ótimo":
                barColor = "#6bd72d";
                break;
            case "Bom":
                barColor = "#6bd72d";
                break;
            case "Regular":
                barColor = "#ecdb23";
                break;
            case "Ruim":
                barColor = "#fe4719";
                break;
            default:
                barColor = "#fe4719";
        }
        let dommax = Math.max(parseDuration(params.meta) * 1.2, parseFloat(conformidade) * 1.2);
        dommax = parseInt(dommax)
        let dommix = Math.min(parseDuration(params.meta) * 0.8, parseFloat(conformidade) * 0.8);
        dommix = parseInt(dommix)

        return h.barChart(
            {
                columns: ["", "Média (segundos)", ""],
                domain: [dommix, dommax],
                // ticks: [0, 1, 2, 3, 4],
                width: 500,
                height: 300,
                meta: parseDuration(params.meta),
                series: [{ name: "", values: [0, parseFloat(conformidade), 0], props: { type: "monotone", fill: barColor } }],
            },
            { alignment: "center", colSpan: 3, width: 180 }
        );
    }

    return indicadorReportSummary(indicador, visita, tipoName, params, getChart, "segundos", "tempoRegistradoSegundos", parseDuration(params.meta));
}
